/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/16/21
 */

import {gql} from "urql";
import {Employee, EmployeesFilter, ListResponse} from "../../interfaces/Global";

export const EmployeesQuery = gql`
    query Employees(
	    $id: String, $idLike: String, $idNotLike: String, $idIn: [String!], $idNotIn: [String!], 
	    $cn: String, $cnLike: String, $cnNotLike: String, $cnIn: [String!], $cnNotIn: [String!], 
	    $company: String, $companyLike: String, $companyNotLike: String, $companyIn: [String!], $companyNotIn: [String!], 
	    $department: String, $departmentLike: String, $departmentNotLike: String, $departmentIn: [String!], $departmentNotIn: [String!], 
	    $displayName: String, $displayNameLike: String, $displayNameNotLike: String, $displayNameIn: [String!], $displayNameNotIn: [String!], 
	    $dn: String, $dnLike: String, $dnNotLike: String, $dnIn: [String!], $dnNotIn: [String!], 
	    $division: String, $divisionLike: String, $divisionNotLike: String, $divisionIn: [String!], $divisionNotIn: [String!], 
	    $firstName: String, $firstNameLike: String, $firstNameNotLike: String, $firstNameIn: [String!], $firstNameNotIn: [String!], 
	    $lastName: String, $lastNameLike: String, $lastNameNotLike: String, $lastNameIn: [String!], $lastNameNotIn: [String!], 
	    $employeeId: Int, $employeeIdIn: [Int!], $employeeIdNotIn: [Int!], 
	    $employeeType: String, $employeeTypeLike: String, $employeeTypeNotLike: String, $employeeTypeIn: [String!], $employeeTypeNotIn: [String!], 
	    $location: String, $locationLike: String, $locationNotLike: String, $locationIn: [String!], $locationNotIn: [String!], 
	    $city: String, $cityLike: String, $cityNotLike: String, $cityIn: [String!], $cityNotIn: [String!], 
	    $state: String, $stateLike: String, $stateNotLike: String, $stateIn: [String!], $stateNotIn: [String!], 
	    $countryCode: String, $countryCodeLike: String, $countryCodeNotLike: String, $countryCodeIn: [String!], $countryCodeNotIn: [String!], 
	    $homeOffice: Boolean,
	    $emailAddress: String, $emailAddressLike: String, $emailAddressNotLike: String, $emailAddressIn: [String!], $emailAddressNotIn: [String!], 
	    $jobTitle: String, $jobTitleLike: String, $jobTitleNotLike: String, $jobTitleIn: [String!], $jobTitleNotIn: [String!], 
	    $personalTitle: String, $personalTitleLike: String, $personalTitleNotLike: String, $personalTitleIn: [String!], $personalTitleNotIn: [String!], 
	    $managerDn: String, $managerDnLike: String, $managerDnNotLike: String, $managerDnIn: [String!], $managerDnNotIn: [String!], 
	    $phoneNumber: String, $phoneNumberLike: String, $phoneNumberNotLike: String, $phoneNumberIn: [String!], $phoneNumberNotIn: [String!], 
	    $uac: Int, $uacIn: [Int!], $uacNotIn: [Int!], $upn: String, $upnLike: String, $upnNotLike: String, $upnIn: [String!], $upnNotIn: [String!], 
	    $whenCreatedGt: Date, $whenCreatedGte: Date, $whenCreatedLt: Date, $whenCreatedLte: Date, 
	    $whenChangedGt: Date, $whenChangedGte: Date, $whenChangedLt: Date,$whenChangedLte: Date, 
	    $isActive: Boolean, 
	    $dateOfBirth: Date, $dateOfBirthGt: Date, $dateOfBirthGte: Date, $dateOfBirthLt: Date, $dateOfBirthLte: Date, 
	    $tags: [String!], 
	    $timeZone: String, $timeZoneLike: String, $timeZoneNotLike: String, $timeZoneIn: [String!], $timeZoneNotIn: [String!], 
	    $startTime: String, $startTimeLike: String, $startTimeNotLike: String, $startTimeIn: [String!], $startTimeNotIn: [String!], 
	    $endTime: String, $endTimeLike: String, $endTimeNotLike: String, $endTimeIn: [String!], $endTimeNotIn: [String!], 
	    $limit: Int, $offset: Int, $orderBy: String, 
	    $managerId: String, $managerIdIn: [String!], $managerIdNotIn: [String!], 
	    $search: String) {
        employees(
            id: $id idLike: $idLike idNotLike: $idNotLike idIn: $idIn idNotIn: $idNotIn
            cn: $cn cnLike: $cnLike cnNotLike: $cnNotLike cnIn: $cnIn cnNotIn: $cnNotIn
            company: $company companyLike: $companyLike companyNotLike: $companyNotLike companyIn: $companyIn companyNotIn: $companyNotIn
            department: $department departmentLike: $departmentLike departmentNotLike: $departmentNotLike departmentIn: $departmentIn departmentNotIn: $departmentNotIn
            displayName: $displayName displayNameLike: $displayNameLike displayNameNotLike: $displayNameNotLike displayNameIn: $displayNameIn displayNameNotIn: $displayNameNotIn
            dn: $dn dnLike: $dnLike dnNotLike: $dnNotLike dnIn: $dnIn dnNotIn: $dnNotIn
            division: $division divisionLike: $divisionLike divisionNotLike: $divisionNotLike divisionIn: $divisionIn divisionNotIn: $divisionNotIn
            firstName: $firstName firstNameLike: $firstNameLike firstNameNotLike: $firstNameNotLike firstNameIn: $firstNameIn firstNameNotIn: $firstNameNotIn
            lastName: $lastName lastNameLike: $lastNameLike lastNameNotLike: $lastNameNotLike lastNameIn: $lastNameIn lastNameNotIn: $lastNameNotIn
            employeeId: $employeeId employeeIdIn: $employeeIdIn employeeIdNotIn: $employeeIdNotIn 
	        employeeType: $employeeType employeeTypeLike: $employeeTypeLike employeeTypeNotLike: $employeeTypeNotLike employeeTypeIn: $employeeTypeIn employeeTypeNotIn: $employeeTypeNotIn
            location: $location locationLike: $locationLike locationNotLike: $locationNotLike locationIn: $locationIn locationNotIn: $locationNotIn
            city: $city cityLike: $cityLike cityNotLike: $cityNotLike cityIn: $cityIn cityNotIn: $cityNotIn
            state: $state stateLike: $stateLike stateNotLike: $stateNotLike stateIn: $stateIn stateNotIn: $stateNotIn
            countryCode: $countryCode countryCodeLike: $countryCodeLike countryCodeNotLike: $countryCodeNotLike countryCodeIn: $countryCodeIn countryCodeNotIn: $countryCodeNotIn
            homeOffice: $homeOffice
            emailAddress: $emailAddress emailAddressLike: $emailAddressLike emailAddressNotLike: $emailAddressNotLike emailAddressIn: $emailAddressIn emailAddressNotIn: $emailAddressNotIn
            jobTitle: $jobTitle jobTitleLike: $jobTitleLike jobTitleNotLike: $jobTitleNotLike jobTitleIn: $jobTitleIn jobTitleNotIn: $jobTitleNotIn
            personalTitle: $personalTitle personalTitleLike: $personalTitleLike personalTitleNotLike: $personalTitleNotLike personalTitleIn: $personalTitleIn personalTitleNotIn: $personalTitleNotIn
            managerDn: $managerDn managerDnLike: $managerDnLike managerDnNotLike: $managerDnNotLike managerDnIn: $managerDnIn managerDnNotIn: $managerDnNotIn
            phoneNumber: $phoneNumber phoneNumberLike: $phoneNumberLike phoneNumberNotLike: $phoneNumberNotLike phoneNumberIn: $phoneNumberIn phoneNumberNotIn: $phoneNumberNotIn
            uac: $uac uacIn: $uacIn uacNotIn: $uacNotIn
            upn: $upn upnLike: $upnLike upnNotLike: $upnNotLike upnIn: $upnIn upnNotIn: $upnNotIn
            whenCreatedGt: $whenCreatedGt whenCreatedGte: $whenCreatedGte whenCreatedLt: $whenCreatedLt whenCreatedLte: $whenCreatedLte whenChangedGt: $whenChangedGt whenChangedGte: $whenChangedGte whenChangedLt: $whenChangedLt whenChangedLte: $whenChangedLte
            isActive: $isActive
            dateOfBirth: $dateOfBirth dateOfBirthGt: $dateOfBirthGt dateOfBirthGte: $dateOfBirthGte dateOfBirthLt: $dateOfBirthLt dateOfBirthLte: $dateOfBirthLte
            tags: $tags
            timeZone: $timeZone timeZoneLike: $timeZoneLike timeZoneNotLike: $timeZoneNotLike timeZoneIn: $timeZoneIn timeZoneNotIn: $timeZoneNotIn
            startTime: $startTime startTimeLike: $startTimeLike startTimeNotLike: $startTimeNotLike startTimeIn: $startTimeIn startTimeNotIn: $startTimeNotIn
            endTime: $endTime endTimeLike: $endTimeLike endTimeNotLike: $endTimeNotLike endTimeIn: $endTimeIn endTimeNotIn: $endTimeNotIn
            limit: $limit offset: $offset orderBy: $orderBy
            managerId: $managerId managerIdIn: $managerIdIn managerIdNotIn: $managerIdNotIn
            search: $search) {
            total,
            items {
                id
                displayName
                company
                countryCode
                department
                division
                employeeId
                city
                firstName
                lastName
	            location
	            startTime
	            endTime
                state
                timeZone
                tags
                phoneNumber
                personalTitle
                jobTitle
                emailAddress
	            properties
                manager {
                    id
                    displayName
                }
            }
        }
    }
`;

export const EmployeesFilterQuery = gql`
    query EmployeesFilter($filter: JSON!) {
        employeesFilter(filter: $filter) {
            total
            items {
                id
                displayName
                company
                countryCode
                department
                division
                employeeId
                city
                firstName
                lastName
                location
                state
                timeZone
                tags
                phoneNumber
                personalTitle
                jobTitle
                emailAddress
                manager {
                    id
                    displayName
                }
	            dateOfBirth
	            dateOfHire
	            timeZone
	            startTime
	            endTime
	            gsacOooEnabled
	            capacityModifier
	            properties
            }
        }
    }
`;

export interface EmployeesFilterVars {
	filter: EmployeesFilter
}

export interface EmployeesFilterResponse {
	employeesFilter: ListResponse<Employee>
}

export const EmployeesSearchQuery = gql`
    query EmployeesSearch($search: String, $idIn: [String!]) {
        employees(search: $search, idIn: $idIn) {
            total
            items {
                id
                displayName
            }
        }
    }
`;

export const EmployeeProductsQuery = gql`
    query EmployeeProducts($search: String) {
        employeeProducts(search: $search)
    }
`;

export const EmployeeLocationsQuery = gql`
    query EmployeeLocations($search: String) {
        employeeLocations(search: $search)
    }
`;

export const EmployeeJobTitlesQuery = gql`
    query EmployeeJobTitles($search: String) {
        employeeJobTitles(search: $search)
    }
`;

export const EmployeeDepartmentsQuery = gql`
    query EmployeeDepartments($search: String) {
        employeeDepartments(search: $search)
    }
`;

export const EmployeeDivisionsQuery = gql`
    query EmployeeDivisions($search: String) {
        employeeDivisions(search: $search)
    }
`;

export const EmployeeTagsQuery = gql`
    query EmployeeTags($search: String) {
        employeeTags(search: $search)
    }
`;

export interface EmployeeSearchVars {
	search?: string
	idIn?: string[]
}

export interface EmployeesQueryResponse {
	employees: ListResponse<Employee>
}

export interface EmployeesQueryVars {
	id?: string 
	idLike?: string 
	idNotLike?: string 
	idIn?: string[]
	idNotIn?: string[]
	cn?: string
	cnLike?: string 
	cnNotLike?: string 
	cnIn?: string[]
	cnNotIn?: string[]
	company?: string
	companyLike?: string 
	companyNotLike?: string 
	companyIn?: string[]
	companyNotIn?: string[]
	department?: string
	departmentLike?: string 
	departmentNotLike?: string 
	departmentIn?: string[]
	departmentNotIn?: string[]
	displayName?: string
	displayNameLike?: string 
	displayNameNotLike?: string 
	displayNameIn?: string[]
	displayNameNotIn?: string[]
	dn?: string
	dnLike?: string 
	dnNotLike?: string 
	dnIn?: string[]
	dnNotIn?: string[]
	division?: string
	divisionLike?: string 
	divisionNotLike?: string 
	divisionIn?: string[]
	divisionNotIn?: string[]
	firstName?: string
	firstNameLike?: string 
	firstNameNotLike?: string 
	firstNameIn?: string[]
	firstNameNotIn?: string[]
	lastName?: string
	lastNameLike?: string 
	lastNameNotLike?: string 
	lastNameIn?: string[]
	lastNameNotIn?: string[]
	employeeId?: number
	employeeIdIn?: number[]
	employeeIdNotIn?: number[]
	employeeType?: string
	employeeTypeLike?: string 
	employeeTypeNotLike?: string 
	employeeTypeIn?: string[]
	employeeTypeNotIn?: string[]
	location?: string
	locationLike?: string 
	locationNotLike?: string 
	locationIn?: string[]
	locationNotIn?: string[]
	city?: string
	cityLike?: string 
	cityNotLike?: string 
	cityIn?: string[]
	cityNotIn?: string[]
	state?: string
	stateLike?: string 
	stateNotLike?: string 
	stateIn?: string[]
	stateNotIn?: string[]
	countryCode?: string
	countryCodeLike?: string 
	countryCodeNotLike?: string 
	countryCodeIn?: string[]
	countryCodeNotIn?: string[]
	homeOffice?: boolean
	emailAddress?: string 
	emailAddressLike?: string 
	emailAddressNotLike?: string 
	emailAddressIn?: string[]
	emailAddressNotIn?: string[]
	jobTitle?: string
	jobTitleLike?: string 
	jobTitleNotLike?: string 
	jobTitleIn?: string[]
	jobTitleNotIn?: string[]
	personalTitle?: string
	personalTitleLike?: string 
	personalTitleNotLike?: string 
	personalTitleIn?: string[]
	personalTitleNotIn?: string[]
	managerDn?: string
	managerDnLike?: string 
	managerDnNotLike?: string 
	managerDnIn?: string[]
	managerDnNotIn?: string[]
	phoneNumber?: string
	phoneNumberLike?: string 
	phoneNumberNotLike?: string 
	phoneNumberIn?: string[]
	phoneNumberNotIn?: string[]
	uac?: number
	uacIn?: number[]
	uacNotIn?: number[]
	upn?: string
	upnLike?: string 
	upnNotLike?: string 
	upnIn?: string[]
	upnNotIn?: string[]
	whenCreatedGt?: Date
	whenCreatedGte?: Date 
	whenCreatedLt?: Date 
	whenCreatedLte?: Date
	whenChangedGt?: Date 
	whenChangedGte?: Date 
	whenChangedLt?: Date 
	whenChangedLte?: Date
	isActive?: boolean
	dateOfBirth?: Date 
	dateOfBirthGt?: Date 
	dateOfBirthGte?: Date 
	dateOfBirthLt?: Date 
	dateOfBirthLte?: Date
	tags?: string[]
	timeZone?: string 
	timeZoneLike?: string 
	timeZoneNotLike?: string 
	timeZoneIn?: string[]
	timeZoneNotIn?: string[]
	startTime?: string
	startTimeLike?: string 
	startTimeNotLike?: string 
	startTimeIn?: string[]
	startTimeNotIn?: string[]
	endTime?: string
	endTimeLike?: string 
	endTimeNotLike?: string 
	endTimeIn?: string[]
	endTimeNotIn?: string[]
	limit?: number
	offset?: number
	orderBy?: string
	managerId?: string 
	managerIdIn?: string[]
	managerIdNotIn?: string[]
	search?: string
}

export const EmployeeQuery = gql`
    query Employee($id: ID!) {
        employee(id: $id) {
            id
            displayName
            company
            countryCode
            department
            division
            employeeId
            city
            firstName
            lastName
            location
            startTime
            endTime
            state
            timeZone
            tags
            phoneNumber
            personalTitle
            jobTitle
            emailAddress
	        capacityModifier
	        gsacOooEnabled
	        dateOfBirth
	        properties
            manager {
                id
                displayName
            }
        }
    }
`;

export interface EmployeeQueryResponse {
	employee: Employee
}

export interface EmployeeQueryVars {
	id: string
}

export const EmployeeHierarchyQuery = gql`
    query Employee($id: ID!, $isActive: Boolean) {
        employee(id: $id) {
	        id
            manager { id }
	        directReports(isActive: $isActive) { id }
        }
    }
`;

export interface EmployeeHierarchyQueryVars {
	id: string
	isActive: boolean
}

export const EmployeePictureUrlQuery = gql`
	query EmployeePictureUrl($employees: [String!]!) {
		employeePictureUrl(employees: $employees) 
	}
`;

export interface EmployeePictureUrlResponse {
	employeePictureUrl: Record<string, string>
}

export interface EmployeePictureUrlVars {
	employees: string[]
}